import http from '@/http/http-common'
import { createTree } from '@/helpers'
import sortBy from 'lodash/sortBy'
import apiResource from '@/helpers/resourceApi'
// import storage from '@/storage'

// const unitCache = storage.namespace('units')

const state = {
    list: [],
    loading: false,
    companies: [],
    company: '',
    unitFilter: '',
    units: [],
    unitsLoading: false,
}

const mutations = {
    setLoading(state, loading) {
        state.loading = loading
    },
    setCompanies(state, companies) {
        state.companies = companies
    },
    setCompany(state, company) {
        // console.log('Setting company', company)
        state.company = company
    },
    setUnits(state, units) {
        state.units = units
        //units.map(unit => unitCache.add(unit.id, unit))
        //state.units = units
    },

    // setUnitFilter(state, filter) {
    //     state.filter = filter.toLowerCase()
    // },
    // filteredUnits(state, filter) {
    //     let units = state.units
    //     filter = filter.toLowerCase()

    //     return units.filter(u => u.name.toLowerCase().indexOf(filter) > -1)
    // },
    // filteredUnitTree() {},
}

const getters = {
    isLoading: state => state.loading,
    companies: state => {
        return sortBy(state.companies, 'name')
    },
    company: state =>
        state.companies.filter(c => c.id == state.company)[0] || {},
    unitTree: state => createTree(state.units),
    units: state => {
        return state.units
        // let units =
        //     state.units.length == 0
        //         ? Object.keys(unitCache.getAll())
        //         : state.units

        // return units.filter(u => u.company_id == state.company)
    },
    rootUnit: state => {
        return state.units.filter(u => u.depth == 0)[0]
    },
}

const actions = {
    setCompany({ commit }, company) {
        commit('setCompany', company)
    },

    getCompanies({ commit }) {
        http.get('/resource/companies?perPage=1000')
            .then(res => {
                commit('setCompanies', res.data.data)
            })
            .finally(() => {
                commit('setLoading', false)
            })
    },

    getUnits({ state, commit }, companyId) {
        if (!companyId) {
            companyId = state.company
        }

        let r = apiResource('units').setFilters({
            company_id: state.company,
        })

        commit('setLoading', true)

        return r.fetch().then(res => {
            commit('setUnits', res.getData().data)
            commit('setLoading', false)
            return res.getData().data
        })
    },

    // Todo: Reintroduce commit
    getUnitList({ state }, companyId) {
        //// console.log('getUnitsAsList Commit', options, http)

        if (!companyId) {
            companyId = state.company
        }

        return http.get('resource/units/getUnitList/' + companyId).then(res => {
            return res.data
        })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}

/**

{
  "url": "/resource/departments",
  "method": "GET",
  "params": {
    "filter": {
      "company_id": "A386D062-BD0D-435E-AA32-441697D78ECA"
    }
  },
  "headers": {}
}
*/
